require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./librairie-1-1-18-1.json") })
        }
      }, "path---librairie-1-1-18-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---librairie-1-1-18-1!./.cache/json/librairie-1-1-18-1.json
// module id = 480
// module chunks = 231608221292675